import React, { useEffect, useState } from "react";
import { StyledPrimaryTypography, StyledSecondaryTypography } from "../Theme";
import { Box, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CREATE from "../Icons/create.png";
import {
  setLoginSliceToNull,
  login,
  setUserDetails,
} from "../Redux/Feature/Login/loginSlice";
import {
  setActiveStep,
  setPropertyId,
  setUserRole,
} from "../Redux/Feature/PropertyDetails/propertyDetailsSlice";
import { showToast } from "../CommonComponents/Toaster";
import { toast, ToastContainer } from "react-toastify";


const ForgotSuccess = ({ setDisplayScreen, email, password }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginStatus } = useSelector((state) => state.Login);
  const [data, setData] = useState({ email: "", password: "" });
  const [errorText, setErrorText] = useState({ email: "", password: "" });
  const [responseError, setResponseError] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    if (loginStatus != null) {
          setLoadingBtn(false);
          if (loginStatus.success) {
            if (loginStatus.data.user_details.user_role == 1) {
              if (loginStatus.data.property_status.status === "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000;
                localStorage.clear();
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
                // dispatch(setPropertyId(loginStatus.data.property_status.id))
                navigate("/propertyDetailsSetup");
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              } else if (loginStatus.data.property_status.status !== "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
                localStorage.clear();
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                toast.success("Login Successful");
                setTimeout(() => {
                  navigate("dashboard");
                }, 1000);
    
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              }
            } else if (loginStatus.data.user_details.user_role == 3) {
              if (loginStatus.data.property_status.status === "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000;
                localStorage.clear();
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
                // dispatch(setPropertyId(loginStatus.data.property_status.id))
                navigate("/propertyDetailsSetup");
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              } else if (loginStatus.data.property_status.status !== "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
                localStorage.clear();
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                toast.success("Login Successful");
                setTimeout(() => {
                  navigate("upcoming_visitor");
                }, 1000);
    
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              }
            } else if (loginStatus.data.user_details.user_role == 2) {
              if (loginStatus.data.property_status.status === "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000;
                localStorage.clear();
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
                // dispatch(setPropertyId(loginStatus.data.property_status.id))
                navigate("/propertyDetailsSetup");
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              } else if (loginStatus.data.property_status.status !== "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
                localStorage.clear();
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                toast.success("Login Successful");
                setTimeout(() => {
                  navigate("dashboard");
                }, 1000);
    
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              }
            } else if (loginStatus.data.user_details.user_role == 4) {
              if (loginStatus.data.property_status.status === "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000;
                localStorage.clear();
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
                // dispatch(setPropertyId(loginStatus.data.property_status.id))
                navigate("/propertyDetailsSetup");
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              } else if (loginStatus.data.property_status.status !== "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
                localStorage.clear();
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                toast.success("Login Successful");
                setTimeout(() => {
                  navigate("upcoming_visitor");
                }, 1000);
    
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              }
            }else if (loginStatus.data.user_details.user_role == 5) {
              if (loginStatus.data.property_status.status === "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000;
                localStorage.clear();
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
                // dispatch(setPropertyId(loginStatus.data.property_status.id))
                navigate("/propertyDetailsSetup");
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              } else if (loginStatus.data.property_status.status !== "onboarding") {
                console.log('called')
                const expiresIn = loginStatus.data.token?.expires_in;
                const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
                localStorage.clear();
                localStorage.setItem(
                  "propertyStatus",
                  JSON.stringify(loginStatus.data.property_status)
                );
                localStorage.setItem(
                  "accessToken",
                  loginStatus.data.token.access_token
                );
                localStorage.setItem(
                  "refreshToken",
                  loginStatus.data.token.refresh_token
                );
                localStorage.setItem(
                  "expireTime",
                  expiresAt
                );
    
                localStorage.setItem(
                  "userDetails",
                  JSON.stringify(loginStatus.data.user_details)
                );
                toast.success("Login Successful");
                setTimeout(() => {
                  navigate("dashboard");
                }, 1000);
    
                dispatch(setLoginSliceToNull());
                dispatch(setPropertyId(loginStatus.data.property_status.id));
                dispatch(setUserRole(loginStatus.data.user_details.user_role));
                dispatch(setUserDetails(loginStatus.data.user_details));
              }
            }
          } else {
            setResponseError(loginStatus.error);
          }
        }
  }, [loginStatus]);

  const confirmToSetup = () => {
    setLoadingBtn(true);
    dispatch(login({ email: email, password: password }));
  };
  return (
    <>
    <ToastContainer />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box component={"img"} src={CREATE} alt="create" sx={{width:300, height:70, cursor:'pointer'}}/>
      </Box>
      <StyledPrimaryTypography sx={{ mt: 2, textAlign: "center" }}>
        Account Password Reset Successful
      </StyledPrimaryTypography>
      <StyledSecondaryTypography sx={{ mt: 2, textAlign: "center" }}>
        Your account password has been successfully reset.
      </StyledSecondaryTypography>
      <StyledSecondaryTypography sx={{ mb: 2, textAlign: "center" }}>
        Click the button below to log in.
      </StyledSecondaryTypography>
      {/* <StyledSecondaryTypography textAlign={"center"}>
        You will have to spend around 10 minutes.
      </StyledSecondaryTypography> */}
      <Button
        disabled={loadingBtn}
        onClick={() => setDisplayScreen("login")}
        sx={{ mt: 4 }}
        fullWidth
        variant="contained"
      >
        {loadingBtn ? <CircularProgress size={25} /> : "Proceed to Login"}
      </Button>
    </>
  );
};

export default ForgotSuccess;
